'use strict';
import DetailsView from '../../../Pandora/model/details-view';
import SelectionTabController from './multiselection-tab';
import template from './multiselection-tab.html';

/**
 * @ngdoc Class
 * @name mx.SolutionBuilderAgent.SelectionView
 *
 * @description
 * View of multi-selection tab
 *
 * @param {Object} options - attributes of view
 *
 */
export default class SelectionView extends DetailsView {
	constructor(i18n, options) {
		options = angular.extend({}, options, {
			controller: SelectionTabController,
			template: template,
			id: 'selectObjects_' + Date.now(),
			headerTitle: i18n.get('solutionBuilderAgent.browseDialog.select_objects_short'),
			displayName: options.displayName,
			name: options.displayName || i18n.get('solutionBuilderAgent.browseDialog.select_label'),
			keepAsOpened: true,
		});

		super(options);
	}
}
